import React, { Component } from 'react';
import { Context } from 'context';

import equals from 'fast-deep-equal';

import styles from 'editor/workspace/window/viewer/toolbar/toolBar.module.scss';
import Mousetrap from "mousetrap";

import segment from "segment";

class FormulaBar extends Component {
    static contextType = Context;

    input = React.createRef();

    state = {
        value: "",
        operator: "=",
        percentage: false
    };

    keys = ["-", ".", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Backspace", "Enter"];

    componentDidMount() {
        this.input.current.addEventListener("keydown", e => {
            if (!this.keys.includes(e.key)) e.preventDefault();
        })
    }

    componentDidUpdate(prevProps) {
        if(!equals(prevProps.selection, this.props.selection)){
            this.setState({
                operator: "=",
                percentage: false
            });
            this.props.updateFormula("");
        }

        const keys = this.keys.map(key => key.toLowerCase());

        if (this.props.focused){
            Mousetrap.bind(keys, this.focus)
        } else {
            Mousetrap.unbind(keys)
        }
    }

    focus = () => this.input.current.focus();

    /**
     * Updates window's state with transformed table using formula in formula bar
     * @param {Object} event
     */
    applyTransform = (event) => {
        segment.track("project_edited", {
            application: "editor",
            type: "formula",
            projectId: this.context.id,
            mapId: this.props.window.mapId,
            axisId: this.props.table.id,
            projectType: this.context.metadata.projectType === "DEMO" ? "demo" : "user",
        })
        event.preventDefault();

        let value = this.state.percentage ?
            (x => x * parseFloat(this.props.formula) / 100):
            (x => parseFloat(this.props.formula));

        let formula;

        switch (this.state.operator) {
            case "=":
                formula = x => value(x);
                break;
            case "+":
                formula = x => x + value(x);
                break;
            case "-":
                formula = x => x - value(x);
                break;
            default:
                formula = x => value(x);
                break;
        }

        this.props.apply(formula);
    };

    updateFormula = (e) => {
        this.props.updateFormula(e.target.value);
    };

    keyPress = (key, event) => {
        if(key !== "="){
            event.preventDefault();

            const position = this.input.current.selectionStart;
            const input = this.props.formula;

            let output = `${input.slice(0, position)}${key}${input.slice(position)}`;
            if(key === "<"){
                output = `${input.slice(0, input.length - 1)}`;
            }

            this.props.updateFormula(output).then(() => {
                this.input.current.setSelectionRange(position + 1, position + 1);
            });
        }
    };

    render() {
        return (
            <form className={`bgSecondary highlightSecondary ${styles.formulaBar}`} onSubmit={this.applyTransform} onTouchStart={this.props.activateNumberPad}>
                <div data-hint={this.context.text.hints.operatorToggles} className={styles.operatorToggles}>
                    <div onClick={() => { this.setState({ operator: "=" })}} className={`highlightSecondary ${this.state.operator === "=" ? styles.active : null}`}>=</div>
                    <div onClick={() => { this.setState({ operator: "+" })}} className={`highlightSecondary ${this.state.operator === "+" ? styles.active : null}`}>+</div>
                    <div onClick={() => { this.setState({ operator: "-" })}} className={`highlightSecondary ${this.state.operator === "-" ? styles.active : null}`}>-</div>
                </div>
                <input
                    ref={this.input}
                    value={this.props.formula}
                    onChange={this.updateFormula}
                    readOnly={this.context.touch ? "readonly" : null}
                    data-hint={this.context.text.hints.formulaBar}
                    className="mousetrap bgSecondary"
                />
                {this.props.numberPad &&
                    <div className={`bgSecondary ${styles.numberPad}`}>
                        <span className="bgSecondary highlightSecondary"/>
                        <div>
                            <button className="highlightSecondary" onClick={this.keyPress.bind(this, 7)}>7</button>
                            <button className="highlightSecondary" onClick={this.keyPress.bind(this, 8)}>8</button>
                            <button className="highlightSecondary" onClick={this.keyPress.bind(this, 9)}>9</button>
                            <button className="highlightSecondary" onClick={this.keyPress.bind(this, 4)}>4</button>
                            <button className="highlightSecondary" onClick={this.keyPress.bind(this, 5)}>5</button>
                            <button className="highlightSecondary" onClick={this.keyPress.bind(this, 6)}>6</button>
                            <button className="highlightSecondary" onClick={this.keyPress.bind(this, 1)}>1</button>
                            <button className="highlightSecondary" onClick={this.keyPress.bind(this, 2)}>2</button>
                            <button className="highlightSecondary" onClick={this.keyPress.bind(this, 3)}>3</button>
                            <button className="highlightSecondary" onClick={(event) => { event.preventDefault(); } } />
                            <button className="highlightSecondary" onClick={this.keyPress.bind(this, 0)}>0</button>
                            <button className="highlightSecondary" onClick={this.keyPress.bind(this, ".")}>.</button>
                        </div>
                        <div>
                            <button className="highlightSecondary" onClick={this.keyPress.bind(this, "<")}>
                                <img src={require('images/icons/backspace-dark.svg')} alt={"Back"} id="formChild" />
                            </button>
                            <button className="highlightSecondary" onClick={this.keyPress.bind(this, "=")}>
                                <img src={require('images/icons/tick.svg')} alt={"Apply"} id="formChild" />
                            </button>
                        </div>
                    </div>
                }
                <div
                    onClick={() => { this.setState({ percentage: !this.state.percentage }) }}
                    className={`highlightSecondary ${styles.percentToggle} ${this.state.percentage ? styles.active : null}`}
                    data-hint={this.context.text.hints.percentageToggle}
                >%</div>
            </form>
        )        
    }
}

export default FormulaBar;
